import { render } from "./join-links.vue?vue&type=template&id=4e7f8fc6&ts=true"
import script from "./join-links.vue?vue&type=script&lang=ts"
export * from "./join-links.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__